import React, { useState, useEffect } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Avatar,
  Text,
  Icon,
  Box,
  Flex,
  Image,
  Button,
  Stack,
  Circle,
} from "@chakra-ui/react";
import "dayjs/locale/lt"; // Import the Lithuanian locale
import "dayjs/locale/en";
import "dayjs/locale/lv";
import "dayjs/locale/pl";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/userActions";
import {
  textSecondary,
  white,
  secondary,
  textPrimary,
  newBorder,
  textBlack,
  primary,
  primaryAlt,
  backgroundLight,
  hoverItemColor,
  color3,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { FaCaretDown } from "react-icons/fa6";
import useThemeColors from "../../hooks/useThemeColors";
import { motion } from "framer-motion";
// import logo from "../../assets/icons/landing/logo.svg";
import LanguageButtonMain from "../buttons/LanguageButtonMain";
// import HeaderTenantSwitch from "./HeaderTenantSwitch";
import useIsMobile from "../../hooks/useIsMobile";
import { TbDental } from "react-icons/tb";

const HeaderMain = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = useIsMobile();

  // COLORS
  const { whiteMode, newBorderMode } = useThemeColors();

  // LANGUAGE

  // STATE

  const [menuOpen, setMenuOpen] = useState(false);
  const [isNoNav, setIsNoNav] = useState(false);

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenant = useSelector((state) => state.tenantDetailsBySlug.tenant);
  const clinicName = tenant?.clinicName || "";
  // get tenant onboarding setup status
  const tenantOnboardingStatus = tenant?.onboarding?.status || "";

  // HANDLERS
  const handleTenantSwitch = (tenantSlug) => {
    const currentPath = location.pathname.split("/"); // Get current URL path
    currentPath[1] = tenantSlug; // Replace the slug part (index 1) with the new tenant slug
    const newPath = currentPath.join("/"); // Join the path back

    navigate(newPath); // Navigate to the new path with the updated slug
  };

  const logoutHandler = () => {
    dispatch(logout());
  };

  const profileHandler = () => {
    navigate(`/${slug}/profile`);
  };

  // USE EFFECT

  useEffect(() => {
    if (location.pathname === "/login" || location.pathname === "/register") {
      setIsNoNav(true);
    } else {
      setIsNoNav(false);
    }
  }, [location.pathname]);

  const activeTenants = userInfo?.tenants?.filter((t) => t.status === "active");

  // LOG
  // console.log("user", userInfo);
  // console.log("tenantOnboardingStatus", tenantOnboardingStatus);
  // console.log("userInfo", userInfo);
  // console.log("activeTenants", activeTenants);

  return (
    <>
      <Box
        position="fixed"
        top="0"
        right={["initial", 0, 0]}
        // left={["0", "initial", "initial"]}
        w="calc(100% - 280px)"
        p="0 2.5rem 0 0rem"
        // h="100%"
        left="280px"
        transition="all 0.2s"
        h="80px"
        borderBottom={`1px solid ${newBorderMode}`}
        bg={whiteMode}
        zIndex={900}
        as={motion.div}
        exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
        initial={{ opacity: 0, x: 0, y: 0 }}
        animate={{
          opacity: 1,
          x: 0,
          y: 0,
          transition: { duration: 0.15 },
        }}
      >
        <Flex
          w="100%"
          p="0 2rem"
          h="100%"
          align="center"
          justify="space-between"
        >
          <Flex></Flex>
          {/* {!userInfo ? (
            <Flex mr="6rem">
              <Link to={`/`}>
                <Image src={logo} h="1.5rem" w="initial" />
              </Link>
            </Flex>
          ) : (
            <Flex display={["flex", "flex", "flex"]} align="center">
              <Flex
                justify="center"
                align="center"
                h="initial"
                w="280px"
                bg={whiteMode}

              >
                <Box p="0rem 0rem 0rem 0rem" w="100%">
                  <HeaderTenantSwitch
                    slug={slug}
                    tenant={tenant}
                    clinicName={clinicName}
                    userInfo={userInfo}
                    handleTenantSwitch={handleTenantSwitch}
                  />
                </Box>
              </Flex>

            </Flex>
          )} */}

          {!isMobile ? (
            <>
              <Flex align="center">
                {/* <ToggleColorModeButton /> */}

                {tenantOnboardingStatus !== "incomplete" && (
                  <Box p="0 0 0 0.5rem" display={["none", "none", "block"]}>
                    <LanguageButtonMain />
                  </Box>
                )}

                {!userInfo ? (
                  <>
                    <Button
                      onClick={() => navigate("/login")}
                      // ml={4}
                      color={textPrimary}
                      borderRadius="10rem"
                      border={`1px solid ${newBorder}`}
                      bg="none"
                      p="0 2rem"
                      fontSize="md"
                      size="lg"
                      className="font-barlow"
                      letterSpacing="1.2px"
                      textTransform="uppercase"
                      _hover={{
                        bg: textBlack,
                        color: white,
                        border: `1px solid ${textBlack}`,
                      }}
                    >
                      {t("landing.navLogin")}
                    </Button>

                    <Link to="/register">
                      <Button
                        size="lg"
                        bg={primary}
                        color={white}
                        // mt={8}
                        // ml={4}
                        // m="1.5rem 0 0"
                        fontSize="1rem"
                        fontWeight="700"
                        borderRadius="10rem"
                        // p="1.5rem 3rem"
                        _hover={{
                          bg: primaryAlt,
                          color: white,
                        }}
                        className="font-barlow"
                        letterSpacing="1.2px"
                        textTransform="uppercase"
                      >
                        {t("landing.navRegister")}
                      </Button>
                    </Link>
                  </>
                ) : (
                  <>
                    <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)}>
                      <MenuButton
                        borderRadius="full"
                        role="group"
                        onClick={() => setMenuOpen(!menuOpen)}
                      >
                        <Flex align="center" ml="30px">
                          <Text
                            color={textSecondary}
                            fontWeight="600"
                            fontSize="sm"
                            mr={3}
                          >
                            {/* {userInfo &&
                          userInfo.firstName &&
                          userInfo.lastName &&
                          userInfo.firstName[0] + ". " + userInfo.lastName} */}
                            {(userInfo && userInfo.email && userInfo.email) ||
                              ""}
                          </Text>
                          <Avatar
                            size="sm"
                            bg={secondary}
                            color={white}
                            name={userInfo && userInfo.email}
                          />
                          <Icon
                            as={FaCaretDown}
                            ml={1}
                            h="0.75rem"
                            w={menuOpen ? "0.75rem" : "0rem"}
                            opacity="0.5"
                            color={textSecondary}
                            transition="all 0.2s ease"
                            transform={
                              menuOpen ? "rotate(180deg)" : "rotate(0)"
                            } // Rotate caret when menu is open
                            _groupHover={{
                              opacity: 1,
                              width: "0.75rem",
                              transition: "all 0.2s ease",
                            }}
                          />
                        </Flex>
                      </MenuButton>

                      <MenuList
                        p={0}
                        m={0}
                        borderRadius="1rem"
                        overflow="hidden"
                      >
                        {userInfo ? (
                          <>
                            <Link to={`/${slug}/profile`}>
                              <MenuItem
                                p="1rem 1rem"
                                onClick={profileHandler}
                                color={textSecondary}
                                fontSize="sm"
                                fontWeight="500"
                                _hover={{
                                  bg: hoverItemColor,
                                  color: textPrimary,
                                }}
                              >
                                <Text>{t("user.myProfile")}</Text>
                              </MenuItem>
                            </Link>
                          </>
                        ) : (
                          <Link to="/login">
                            <MenuItem
                              p="1rem 1rem"
                              color={textSecondary}
                              fontSize="sm"
                              fontWeight="500"
                              _hover={{
                                bg: hoverItemColor,
                                color: textPrimary,
                              }}
                            >
                              <Text>
                                <i className="fas fa-user"></i>{" "}
                                {t("common.signin")}
                              </Text>
                            </MenuItem>
                          </Link>
                        )}

                        {activeTenants && activeTenants?.length > 1 && (
                          <>
                            {/* <Box borderBottom="1px solid #eee" /> */}
                            <MenuItem disabled bg={backgroundLight}>
                              <Text
                                fontSize="xs"
                                fontWeight="500"
                                color="gray.500"
                              >
                                {t("user.tenantList")}
                              </Text>
                            </MenuItem>

                            {activeTenants.map((tenant) => {
                              const isActiveTenant = tenant.slug === slug;

                              return (
                                <MenuItem
                                  key={tenant.tenantID}
                                  onClick={() =>
                                    handleTenantSwitch(tenant.slug)
                                  } // Call the function with the new tenant slug
                                  bg={
                                    tenant.tenantID === userInfo.tenantID
                                      ? "gray.50"
                                      : "transparent"
                                  }
                                  p="0.5rem 1rem"
                                  borderBottom={`1px solid ${newBorderMode}`}
                                  _hover={{
                                    bg: hoverItemColor,
                                    color: textPrimary,
                                  }}
                                  // _last={{
                                  //   borderBottom: "none",
                                  // }}
                                >
                                  <Flex align="center" position="relative">
                                    {isActiveTenant && (
                                      <Circle
                                        position="absolute"
                                        bottom="0"
                                        left="20px"
                                        w="0.75rem"
                                        h="0.75rem"
                                        border={`2px solid ${whiteMode}`}
                                        bg={color3}
                                      />
                                    )}

                                    {tenant?.logo ? (
                                      <Image
                                        src={tenant.logo}
                                        alt={clinicName}
                                        w="2rem"
                                        h="2rem"
                                        borderRadius="0.75rem"
                                        objectFit="cover"
                                        mr="0.5rem"
                                      />
                                    ) : (
                                      <Flex
                                        align="center"
                                        justify="center"
                                        h="2.5rem"
                                        w="2.5rem"
                                        borderRadius="100%"
                                        bg={backgroundLight}
                                        // border={`1px solid ${newBorder}`}
                                        mr="0.5rem"
                                      >
                                        <Icon
                                          as={TbDental}
                                          color={textSecondary}
                                          fontSize="0.875rem"
                                        />
                                      </Flex>
                                      // <Box
                                      //   w="2.25rem"
                                      //   h="2.25rem"
                                      //   borderRadius="0.75rem"
                                      //   border="1px solid #ccc"
                                      //   display="flex"
                                      //   alignItems="center"
                                      //   justifyContent="center"
                                      //   mr="0.5rem"
                                      // >
                                      //   <MdImageNotSupported />
                                      // </Box>
                                    )}

                                    <Stack gap={0}>
                                      <Text
                                        fontSize="sm"
                                        fontWeight="500"
                                        color={textPrimary}
                                        maxW="160px"
                                        isTruncated
                                      >
                                        {isActiveTenant
                                          ? clinicName
                                          : tenant.clinicName}
                                      </Text>
                                      <Text fontSize="xs" color={textSecondary}>
                                        {t(`role.${tenant.role}`)}
                                      </Text>
                                    </Stack>
                                  </Flex>
                                </MenuItem>
                              );
                            })}
                            {/* <Box borderBottom="1px solid #eee" /> */}
                          </>
                        )}

                        <MenuItem
                          p="1rem 1rem"
                          onClick={logoutHandler}
                          fontSize="sm"
                          fontWeight="500"
                          color={textSecondary}
                          _hover={{
                            bg: hoverItemColor,
                            color: textPrimary,
                          }}
                        >
                          <Text>{t("common.logout")}</Text>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </>
                )}
              </Flex>
            </>
          ) : (
            <Flex align="center"></Flex>
          )}
        </Flex>
      </Box>
    </>
  );
};

export default HeaderMain;
